import gql from "graphql-tag";

export const DOCUMENT_MESSAGE_FIELDS_FRAGMENT = gql`
	fragment DocumentMessageFields on DocumentMessage {
		id
		createdOn
		resolvedOn
		content
		sharingType
		isAssignment
		sourceTenantId
		systemMessageName
		attachmentFileNames
		sentBy {
			id
			email
			isDeleted
			firstName
			lastName
			organization {
				id
				name
			}
		}
		resolvedBy {
			id
			isDeleted
			email
			firstName
			lastName
		}
		refunds {
			id
			isDeleted
		}
		cases {
			id
			isDeleted
		}
		agreements {
			id
			isDeleted
		}
	}
`;

export const CREATE_DOCUMENT_MESSAGE = gql`
	${DOCUMENT_MESSAGE_FIELDS_FRAGMENT}

	mutation CreateDocumentMessage($input: CreateDocumentMessageInput!) {
		CreateDocumentMessage(input: $input) {
			pendingMessageId
			message {
				...DocumentMessageFields
			}
		}
	}
`;

export const RESOLVE_ASSIGNMENT = gql`
	${DOCUMENT_MESSAGE_FIELDS_FRAGMENT}

	mutation ResolveAssignment($id: ID!) {
		ResolveAssignment(id: $id) {
			...DocumentMessageFields
		}
	}
`;

export const UNRESOLVE_ASSIGNMENT = gql`
	${DOCUMENT_MESSAGE_FIELDS_FRAGMENT}

	mutation UnresolveAssignment($id: ID!) {
		UnresolveAssignment(id: $id) {
			...DocumentMessageFields
		}
	}
`;

export const DELETE_DOCUMENT_MESSAGE = gql`
	mutation DeleteDocumentMessage($id: ID!) {
		DeleteDocumentMessage(id: $id)
	}
`;

export const UNDELETE_DOCUMENT_MESSAGE = gql`
	mutation UndeleteDocumentMessage($id: ID!) {
		UndeleteDocumentMessage(id: $id)
	}
`;

export const DOCUMENT_THREAD_SUBSCRIPTION = gql`
	${DOCUMENT_MESSAGE_FIELDS_FRAGMENT}

	subscription OnDocumentThreadUpdated {
		documentThreadUpdated {
			documentId
			message {
				...DocumentMessageFields
			}
			deletedMessageId
			initiatorUserEmail
		}
	}
`;

export const GET_USERS_TO_MENTION_ON_DOCUMENT_MESSAGE = gql`
	query GetUsersToMentionOnDocumentMessage($id: ID!) {
		GetUsersToMentionOnDocumentMessage(id: $id) {
			email
			firstName
			lastName
		}
	}
`;

export const GET_DOCUMENT_MESSAGE_ATTACHMENT = gql`
	query GetDocumentMessageAttachment($messageId: ID!, $attachmentIndex: Int!) {
		GetDocumentMessageAttachment(messageId: $messageId, attachmentIndex: $attachmentIndex)
	}
`;

export const CANCEL_ATTACHMENT_UPLOAD = gql`
	mutation CancelAttachmentUpload($pendingMessageId: ID!) {
		CancelAttachmentUpload(pendingMessageId: $pendingMessageId)
	}
`;

export const DOCUMENT_ATTACHMENT_PROGRESS_SUBSCRIPTION = gql`
	subscription DocumentAttachmentProgress {
		documentAttachmentProgress {
			messageId
			stage
			virusFoundInFiles
			attachmentFileNames
		}
	}
`;
